import React from "react";
import { AuthContext } from "../utility/AuthContext";
import { useContext } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Header({ setSidebarCollapsed }) {
  const [dropdown, setDropdown] = useState(false);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { logout } = useContext(AuthContext);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const showProfile = () => {
    setDropdown(!dropdown);
  };

  return (
    <div
      className="text-white position-relative px-4"
      style={{ backgroundColor: "#6366F1", height: "200px" }}
    >
      <i
        className="bi bi-list position-absolute top-0 start-0 p-3 fs-2"
        onClick={() => setSidebarCollapsed((prev) => !prev)}
        style={{ cursor: "pointer" }}
      ></i>

      <div
        className="position-absolute top-0 end-0 p-3 text-end"
        style={{ fontSize: "18px" }}
        onClick={showProfile}
      >
        <span style={{ cursor: "pointer" }}>
          Current User : {user.userName}
        </span>
        <div
          className="dropdown"
          style={{ display: dropdown ? "block" : "none" }}
        >
          <ul
            style={{ listStyleType: "none", width: "max-content" }}
            className="bg-white p-3 rounded shadow ms-auto"
          >
            <li
              onClick={handleLogout}
              className="text-dark d-flex flex-row gap-3"
              style={{ cursor: "pointer" }}
            >
              <i className="bi bi-box-arrow-left"></i>
              Logout
            </li>
          </ul>
        </div>
      </div>

      <div className="position-absolute bottom-0 start-0 p-3">
        <h2 className="mb-3 ">
          SHRADHANAND BAL MANDIR SENIOR SECONDARY SCHOOL
        </h2>
        <p>© 2025 Script IT Solution</p>
      </div>
    </div>
  );
}
